<template>
  <div class="container text-center index-page pt-5">

    <h1>TecknaEl Partner Kontrollpanel</h1>

    <div class="logo mt-5 pt-5">
      <img src="http://cdn.tecknael.se/images/misc/logo-color.png">
    </div>

    <div class="mt-5 pt-5">
      <small class="text-muted">
        För att logga in vänligen använd inloggningslänken som du har fått skickad på mejl. Om du inte har fått din inloggningslänk var god kontakta oss på <a href="mailto:hej@tecknael.se">partner@tecknael.se</a>
      </small>
    </div>

  </div>
</template>

<script>

  //todo - if signup already exists in cookies, store - redirect inside

  export default {
    name: "Index",
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Index.vue